'use client';

import { Box } from '@wishket/design-system';

import useFortune from './useFortune';

import { FortuneTitle, Fortune as FortuneFeature } from '@/features/Landing';

const FortuneBody = () => {
  const { fortuneText, fortuneStatus, requestFortune } = useFortune();

  if (fortuneStatus === 'error')
    return <FortuneFeature.Error onRetry={requestFortune} />;

  if (fortuneStatus === 'loading') return <FortuneFeature.Loading />;

  if (fortuneStatus === 'success')
    return (
      <FortuneFeature.Success
        fortune={fortuneText || ''}
        onRetry={requestFortune}
      />
    );

  return <FortuneFeature.Default onRequest={requestFortune} />;
};

const Fortune = () => {
  return (
    <Box className="flex flex-col gap-4">
      <FortuneTitle />
      <FortuneBody />
    </Box>
  );
};

export default Fortune;
